<template>
  <b-card>
    <b-row>
      <b-col>
        <h3>{{ $route.name + ' | ' + getDate(today.clockInTime) }}</h3>
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item
            ><router-link to="/attendance/">Attendance</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="border-bottom mb-3"></div>
        <div v-if="isLoading">
          <div class="text-center" style="margin: 3% auto;">
            <b-spinner small type="grow" label="Small Spinner"></b-spinner>
            <b-spinner small variant="primary" type="grow" label="Small Spinner"></b-spinner>
            <b-spinner small variant="success" type="grow" label="Small Spinner"></b-spinner>
          </div>
        </div>
        <div v-else>
          <b-row class="mt-3 mb-2">
            <b-col lg="6">
              <b-row>
                <b-col md="3">
                  <label class="labels">Name</label>
                </b-col>
                <b-col md="3" class="d-flex">
                  <p style="margin-right: 8px;">
                    {{ today.userProfile }}
                  </p>
                  <!-- {{ today.userProfile.lastName !== null ? today.userProfile.lastName : '-' }} -->
                </b-col>
              </b-row>

              <!-- <b-row>
                <b-col md="3">
                  <label class="labels">Date</label>
                </b-col>
                <b-col md="3">
                  <p v-text="getDate(today.clockInTime)"></p>
                </b-col>
              </b-row> -->

              <b-row>
                <b-col md="3">
                  <label class="labels">Out Station</label>
                </b-col>
                <b-col md="3">
                  <div v-if="today.isOutstation === true">
                    <i class="fa fa-check" aria-hidden="true"></i>
                  </div>
                  <div v-else>
                    <p>-</p>
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="3">
                  <label class="labels">Clock In</label>
                </b-col>
                <b-col md="3">
                  <p
                    v-text="
                      today.clockInTime !== null
                        ? new Date(today.clockInTime).toLocaleTimeString().replace('.', '.')
                        : '-'
                    "
                  ></p>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="3">
                  <label class="labels">Clock Out</label>
                </b-col>
                <b-col md="3">
                  <p
                    v-text="
                      today.clockOutTime !== null
                        ? new Date(today.clockOutTime).toLocaleTimeString().replace('.', '.')
                        : '-'
                    "
                  ></p>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="3">
                  <label class="labels">Start Break</label>
                </b-col>
                <b-col md="3">
                  <p
                    v-text="
                      today.breakInTime !== null
                        ? new Date(today.breakInTime).toLocaleTimeString().replace('.', '.')
                        : '-'
                    "
                  ></p>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="3">
                  <label class="labels">End Break</label>
                </b-col>
                <b-col md="3">
                  <p
                    v-text="
                      today.breakOutTime !== null
                        ? new Date(today.breakOutTime).toLocaleTimeString().replace('.', '.')
                        : '-'
                    "
                  ></p>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="3">
                  <label class="labels">Total Minutes Late</label>
                </b-col>
                <b-col md="3">
                  <p v-if="today.totalMinutesLate !== null && today.totalMinutesLate !==0">{{ today.totalMinutesLate !== null && today.totalMinutesLate !==0 ? today.totalMinutesLate : '-' }}{{' Minutes'}}</p>
                  <p v-else>-</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="3">
                  <label class="labels">Total Hour</label>
                </b-col>
                <b-col md="3">
                  <p>{{ today.clockHour !== null ? today.clockHour : '-' }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="3">
                  <label class="labels">Total Break Hour</label>
                </b-col>
                <b-col md="3">
                  <p>{{ today.breakHour !== null ? today.breakHour : '-' }}</p>
                </b-col>
              </b-row>

              <b-row class="mt-3 mb-2">
                <b-col md="3">
                  <label class="labels pt-5 mt-5">Clock In Picture</label>
                </b-col>
                <b-col md="3">
                  <viewer>
                    <b-row>
                      <b-col md="3">
                        <p
                          class="text-secondary text-center border p-5 d-flex"
                          v-if="today.clockInPicture === null"
                        >
                          <i>No Photo Submitted</i>
                        </p>
                        <b-img
                          :src="today.clockInPicture"
                          class="img-responsive "
                          v-b-tooltip.focus
                          title="Click to view image"
                          width="300"
                          height="200"
                        />
                      </b-col>
                    </b-row>
                  </viewer>
                </b-col>
              </b-row>

              <b-row class="mt-3 mb-2">
                <b-col md="3">
                  <label class="labels pt-5 mt-5">Clock Out Picture</label>
                </b-col>
                <b-col md="3">
                  <viewer>
                    <b-row>
                      <b-col md="3">
                        <!-- <p
                    class="text-secondary text-center border p-5 d-flex"
                    v-if="today.clockOutPicture == null"
                  >
                    <i>No Photo Submitted</i>
                  </p> -->
                        <b-img
                          :src="today.clockOutPicture"
                          v-b-tooltip.focus
                          title="Click to view image"
                          class="img-responsive"
                          width="300"
                          height="200"
                          alt="no photo submited"
                        />
                      </b-col>
                    </b-row>
                  </viewer>
                </b-col>
              </b-row>
            </b-col>

            <b-col lg="6">
              <b-tabs content-class="mt-3 h-auto">
                <b-tab title="Clock In Location" active style="height: 700px">
                  <label class="labels">Clock In Location</label>
                  <GmapMap
                    v-if="today.clockInLatitude !== 0"
                    :center="today.positionIn"
                    :zoom="17"
                    map-type-id="terrain"
                    style="width: 100%; height: 70%"
                  >
                    <GmapMarker
                      :position="today.positionIn"
                      :clickable="true"
                      :draggable="true"
                      @click="center = today.positionIn"
                    />
                  </GmapMap>
                  <div v-else>
                    <h6 class="text-center text-secondary">No Location Found!</h6>
                  </div>
                </b-tab>
                <b-tab title="Clock Out Location" style="height: 700px">
                  <label class="labels">Clock Out Location</label>
                  <GmapMap
                    v-if="today.clockOutLatitude !== 0"
                    :center="today.positionOut"
                    :zoom="17"
                    map-type-id="terrain"
                    style="width: 100%; height: 70%"
                  >
                    <GmapMarker
                      :position="today.positionOut"
                      :clickable="true"
                      :draggable="true"
                      @click="center = today.positionOut"
                    />
                  </GmapMap>
                  <div v-else>
                    <h6 class="text-center text-secondary">No Location Found!</h6>
                  </div>
                </b-tab>
              </b-tabs>
            </b-col>

            <b-col lg="6"> </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-button class="mt-3 mb-5" @click="goBack" variant="secondary"
      ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
    >
  </b-card>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vue from 'vue';
Vue.use(Viewer);

export default {
  data() {
    return {
      isLoading: false,
      src: '',
      today: {
        clockInTime: null,
        clockInLatitude: 0,
        clockInLongitude: 0,
        clockInPicture: null,
        clockInNote: null,
        clockOutTime: null,
        clockOutLatitude: 0,
        clockOutLongitude: 0,
        clockOutPicture: null,
        clockOutNote: '',
        clockHour: null,
        clockTimeDiff: null,
        breakInTime: null,
        breakInLatitude: 0,
        breakInLongitude: 0,
        breakInPicture: null,
        breakInNote: null,
        breakOutTime: null,
        breakOutLatitude: 0,
        breakOutLongitude: 0,
        breakOutPicture: null,
        breakOutNote: null,
        breakHour: null,
        breakTimeDiff: null,
        isOutstation: null,
        totalMinutesLate: null,
        createdAt: '',
        updatedAt: '',
        uuid: '',
        account: '',
        userProfile: '',
        position: {
          lat: 0,
          lng: 0,
        },
        positionIn: { lat: 0, lng: 0 },
        positionOut: { lat: 0, lng: 0 },
      },
      items: [],
      images: '',
      canShowRoutePath: {
        type: String,
        required: false,
        default: '',
      },
      dataKey: '',
      apiUrl: {
        attendance: window.AppConfig.apiUrl + 'attendance',
        attendanceReport: window.AppConfig.apiUrl + 'attendance-report',
      },
    };
  },

  mounted() {
    this.getUserHistoryDetail();
    this.getDate();
    this.getClockTime();
  },

  methods: {
    getUserHistoryDetail() {
      this.isLoading = true;
      this.$http.get(this.apiUrl.attendance + '/' + this.$route.params.uuid).then((resp) => {
        this.items = resp.data;
        this.today = resp.data;

        const d = resp.data;
        (this.today.positionIn = {
          lat: d.clockInLatitude,
          lng: d.clockInLongitude,
        }),
          (this.today.positionOut = {
            lat: d.clockOutLatitude,
            lng: d.clockOutLongitude,
          }),
          (this.today.positionBreakIn = {
            lat: d.breakInLatitude,
            lng: d.breakInLongitude,
          }),
          (this.today.positionBreakOut = {
            lat: d.breakOutLatitude,
            lng: d.breakOutLongitude,
          });
        setTimeout(() => {
          this.isLoading = false;
        }, 1500);
      });
    },

    getHistories(){
      this.$http.get(this.apiUrl.attendance + '?user_uuid=' + this.$route.params.uuid).then(resp=>{
        this.dataUser = []
        this.dataUser = resp.data._embedded.attendance
        this.userProfile = resp.data._embedded.attendance[0].userProfile
        console.log('history', this.model.userProfile );
      })
    },

    getClockTime(value) {
      if (value !== null) {
        return this.$moment(value).format('HH:mm');
      } else {
        return '-';
      }
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('H:mm DD MMMM YYYY');
      } else {
        return '-';
      }
    },

    getDate(value) {
      if (value !== null) {
        return this.$moment(value).format('DD MMMM YYYY');
      } else {
        return '-';
      }
    },

    goBack() {
      window.goBack(this);
    },
  },
};
</script>

<style scoped>
.fa-check{
  color:#fff;
  font-size: 22px;
  background-color: rgb(5, 151, 5);
  width: 36px;
  border-radius: 6px;
  text-align: center;
}
</style>
